export default __webpack_public_path__ + "static/media/unknown.11cdbeba.jpg";